import moment from 'moment-timezone';
import { computed } from '@ember/object';
import { Entities, Periods } from 'cio/utils/metrics/common';

export class TrackedLinkMetricStat {
  linkId: string;
  href: string;
  clicked: number[];
  totalClicked: number;

  period: Periods;

  @computed('clicked.[]', 'period')
  get periodTotalClicked() {
    let data = this.clicked;
    // The "days" period includes 45 data entries instead of 30, so we need to
    // trim the array.
    // For other periods it's safe to add all the numbers.
    if (this.period === Periods.DAYS) {
      data = data.slice(-30);
    }

    return data.reduce((a, b) => a + b);
  }

  constructor(obj: any, period: Periods) {
    this.linkId = obj.link_id;
    this.href = obj.href;
    this.clicked = obj.clicked;
    this.totalClicked = obj.total_clicked;

    this.period = period;
  }
}

export class TrackedLinkMetric {
  entityId: number | string;
  entityType: Entities;
  actionType: string | null;
  period: Periods;
  resolution: Periods;
  range: { start?: moment.Moment; end?: moment.Moment } | null;
  fetchedAt: number; // unix timestamp when this metric was received from the API

  stats: TrackedLinkMetricStat[] = [];

  environmentId?: number;
  campaignId?: number;

  constructor(obj: any) {
    this.entityId = obj.entityId;
    this.entityType = obj.entityType;
    this.actionType = obj.actionType;
    this.period = obj.period;
    this.resolution = obj.resolution;
    this.range = obj.range;

    this.fetchedAt = Math.floor(Date.now() / 1000);

    if (obj.meta?.environmentId) {
      this.environmentId = obj.meta.environmentId;
    }

    if (obj.meta?.campaignId) {
      this.campaignId = obj.meta.campaignId;
    }

    this.stats = obj.values.map((stat: any) => new TrackedLinkMetricStat(stat, obj.period));
  }
}
